import { QueryObserverOptions, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { getTraceabilityInitial } from './api';
import { QueryKey } from '@behavior/QueryKey';
import { ActivityTraceabilityDTO } from './dto/ActivityTraceabilityDTO';

type UseQueryOptionsKeys = Pick<QueryObserverOptions, 'enabled' | 'retry' | 'onSuccess'>;

export default function useTraceabilityInitialData(options?: UseQueryOptionsKeys) {
  const { t } = useTranslation();
  const { data: traceabilityInitial, isFetching } = useQuery<ActivityTraceabilityDTO>(
    [`${QueryKey.TRACEABILITY_INITIAL}`],
    () => getTraceabilityInitial(),
    {
      enabled: true,
      onError: error => {
        toast.error(t('message.title.error.get.traceability'));
      },
      ...options,
    }
  );
  return { traceabilityInitial: traceabilityInitial, isFetching, getTraceabilityInitial };
}
